import { Component, Input } from '@angular/core';

@Component({
  selector: 'notification-msg',
  templateUrl: './notification-msg.component.html',
  styleUrl: './notification-msg.component.css',
  standalone: false
})
export class NotificationMsgComponent {
  @Input() type: 'warning' | 'error' | 'success' = 'warning';
  @Input() message: string = '';

  getIconPath(): string {
    switch (this.type) {
      case 'error':
        return 'assets/img/error_icon.svg';
      case 'success':
        return 'assets/img/success_icon.svg';
      case 'warning':
      default:
        return 'assets/img/traingle_warning.svg';
    }
  }
}
